import { BrowserRouter } from "react-router-dom"
import "./App.css"
import MainRoute from "./router/MainRoute"
import { ToastContainer } from "react-toastify"
import { useEffect } from "react";

function App() {

  useEffect(() => {
    // Set the `app_id` cookie from environment variable
    const loginAppId = process.env.REACT_APP_CURRENT_APP_ID || '0';  // Default to '0' if not set in .env
    document.cookie = `app_id=${loginAppId}; path=/;`; // Setting a cookie accessible to the whole site

    // Optional: Ensure the cookie is HttpOnly and Secure if necessary
    // document.cookie = `app_id=${loginAppId}; path=/; HttpOnly; Secure; SameSite=Strict`;

  }, []); // This useEffect will run once when the app loads
  
  return (
    <BrowserRouter>
      <ToastContainer autoClose={2000} />
      <MainRoute />
    </BrowserRouter>
  )
}

export default App
